export enum InternalMessageType {
  GalleryReady = 'galleryReady',
  GalleryVisibility = 'galleryVisibility',
  OpenDialog = 'openDialog',
  PrefetchDialog = 'prefetchDialog',
  Resize = 'resize',
}
